import { AccountType } from 'src/utils/enums/payment.enum';
import { useLocalization } from 'src/utils/useLocalization';

interface IProps {
    country: string;
    brand: string;
    accountType: string;
}

const QuoteNotes = ({ country, brand, accountType }: IProps) => {
    const { payoffQuotesDetailInfo } = useLocalization();

    return (
        <>
            {accountType == AccountType.RetailLoan && (
                <>
                    <div>
                        {country.toLocaleLowerCase().includes('can')
                            ? brand == 'VW'
                                ? payoffQuotesDetailInfo.NOTE_CA_VW
                                : payoffQuotesDetailInfo.NOTE_CA_AU
                            : brand == 'VW'
                            ? payoffQuotesDetailInfo.NOTE_US_VW
                            : payoffQuotesDetailInfo.NOTE_US_AU}
                    </div>
                    {country == 'Canada' ? (
                        <div className='quote-note'>
                            VW Credit Canada, Inc.
                            <br />
                            500-1340 Pickering Pky Pickering, ON L1V 0C4
                            <br />
                            {payoffQuotesDetailInfo.ATTENTION}
                            <br />
                        </div>
                    ) : (
                        <div className='quote-note'>
                            {brand == 'VW' ? (
                                <a href='https://www.volkswagendirect.us/landing'>
                                    VolkswagenDirect.com
                                </a>
                            ) : (
                                <a href='https://audidirect.us/landing'>
                                    AudiDirect.com
                                </a>
                            )}
                        </div>
                    )}
                </>
            )}
            <div className='quote-note'>{payoffQuotesDetailInfo.ADVICE}</div>
            <div className='quote-note'>
                <span className='quote-note-label'>
                    {payoffQuotesDetailInfo.LABEL}:{' '}
                </span>
                {payoffQuotesDetailInfo.PAYMENT}
            </div>
        </>
    );
};

export default QuoteNotes;
